//#region src/variants/variants_emoji_text_wrapper.js
var variants_emoji_text_wrapper_default = {
	defaults: { props: { size: { tokenCategory: "icon-size" } } },
	default: { slots: { default: { initialValue: "Some text with :invalid-emoji: :smile: :cry: and 😄, and custom emojis " } } }
};
//#endregion
export { variants_emoji_text_wrapper_default as default };

//# sourceMappingURL=variants_emoji_text_wrapper.js.map